"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Noop = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
/**
 * # 😐 Noop
 *
 * A component that does... nothing!
 */
const Noop = ({ children }) => {
    if (children && react_1.default.isValidElement(children)) {
        return children;
    }
    return null;
};
exports.Noop = Noop;
